'use strict';

const authenticateViaToken = require('./auth-via-token');
const tryAgain = require('../try-again');

const authenticate = (getUser, options = {}) => {
  let logTokenAuthFailure = (failure) => {
    console.log('Refused to try token authentication. Reason:', failure);

    return failure;
  };
  
  return authenticateViaToken(options)
    .fail(logTokenAuthFailure)
    .then((response) => tryAgain(getUser, null, options));
};

module.exports = authenticate;
